import React from "react";
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormSH from '../../../../library/form/components/FormSH';
import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';

const DashViewByGroupRow = (props) => {
    const { formObject, rowKey, viewData, sarasDnDManager, dashRowId, reloadData, groupHeight, groupClass } = props;

    // console.log("worker 1", viewData);

    const renderDashGroupRow = (rowId, index) => {
        let row = sarasDnDManager.getGroupRow(viewData, rowId);

    // console.log("worker 2", row);

        let DynamicComponent = formObject.viewMap[row.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vTaskDashRow"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            // console.log("rerendered");
            
            return (
                <DynamicComponent formObject={formObject} index={index} rowKey={rowId} viewData={row} key={index} dashRowId={dashRowId}
                    groupKey={rowKey} isSortMode={sarasDnDManager.isSortMode()}
                />
            )
        }
    }

    return (
        <div style={{height: `${groupHeight-46}px`}} className={`group-row uiInline ${groupClass}`} >
        <div id="dashContainer"  className="uiBoxBlue uiBoxSection uiContentCenter uiBorderRoundAll uiBoxSection170 uiDashboardGroup uiDashViewD" style={{minWidth:"185px", height: `${groupHeight-30-46}px`}}>
            <div className="uiHeaderBlock">
                <div className="uiBlock uiContentCenter" style={{margin:"-5px"}}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "groupTitle" }} className='uiBlock uiDashGroupTitle'/>
                </div>
            </div>
            <div className="uiContentBlock" style={{ marginTop: "12px", minWidth:"160px", width:"fit-content", height: `${groupHeight-30-50-46}px` }}>
                <SarasDnDList groupKey={rowKey} sarasDnDManager={sarasDnDManager} >
                    {
                        sarasDnDManager.getGroupRowsKeys(viewData).map((rowId,index)=>(
                            renderDashGroupRow(rowId,index)
                        ))
                    }
                </SarasDnDList>
            </div >
            <div className="uiFooterBlock">
                <div className="uiFlexBox3">
                    <FormButton formObject={formObject} rowKey={rowKey}  className="dash-print uiPrint uiDashSHLink" tooltip="Activity Log Report"
                        starIcon="timesheet"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        action={{ actionId: "print",  paramName: "printActivityLog", actionMessage:"Creating Log Report",
                        actionParam: { cGroup: '%dataList.groupId', dashprint:'%dataList.dashprint', rptName:'%dataList.rptName',dshv_rowId:dashRowId }, 
                        containerKey: "popup" }}
                    />
                    <FormButton formObject={formObject} rowKey={rowKey}  className="dash-print uiPrint uiDashSHLink" tooltip="Call Report"
                        starIcon="task"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        action={{ actionId: "print",  paramName: "printCallReport", actionMessage:"Creating Call Report",
                        actionParam: { cGroup: '%dataList.groupId', dashprint:'%dataList.dashprint', rptName:'%dataList.rptName',dshv_rowId:dashRowId }, 
                        containerKey: "popup" }}
                    />
                    <FormSH formObject={formObject} rowKey={rowKey} style={{}}
                        action={{ actionId: "new", paramName: "taskSH",  onModalClose:reloadData,
                        actionParam: { cGroup: '%dataList.groupId', viewCaller: "InDashboard",dshv_rowId:dashRowId, 
                        dsh_docid:formObject.masterKeys.dId, dsh_wrksid: formObject.masterKeys.wsId}, actionMessage:"Creating New Task",
                        skipMasterKey:0, containerKey: "popup" }}
                        className="uiLink uiIcon" >
                    </FormSH>
                </div>
            </div>
        </div >
        </div>
    )
}

export default DashViewByGroupRow
